import React from "react";
import SimpleLayout from "../../../layouts/SimpleLayout";
import { SSOOptions } from "../../../components";

const Sso = () => {
  return (
    <SimpleLayout contentClass="w-85">
      <h1 className="tablet-landscape:text-22p text-28p text-white font-bold mb-4 tablet-landscape:text-left text-center ">
        Enter your email address
      </h1>
      <SSOOptions />
    </SimpleLayout>
  );
};

export default Sso;
